if (!customElements.get('home-youtube-list')) {
    customElements.define(
        'home-youtube-list',
        class HomeYoutubeList extends HTMLElement {
            constructor() {
                super();
                this.hyswiper = null;
            }

            connectedCallback() {
                const container = this.querySelector('.swiper');
                if (!container) return;

                const speed = parseInt(container.dataset.speed);

                const slides = container.querySelectorAll('.swiper-slide');
                const slidesCount = slides.length;
                this.hyswiper = new Swiper(container, {
                    speed: speed || 3000,
                    loop: true,
                    // loopedSlides: 5,
                    loopAdditionalSlides: 1,
                    autoplay: {
                        delay: 0,
                        disableOnInteraction: false,
                    },
                    slidesPerView: 'auto',
                    slidesPerGroup: 1,
                    // slidesPerView: 12,
                    // centeredSlides: true,
                    // watchSlidesProgress: true,
                    // mousewheel: true,
                });

                this.hyswiper.el.onmouseover = () => this.hyswiper.autoplay.stop();
                this.hyswiper.el.onmouseout = () => this.hyswiper.autoplay.start();

                // console.log('🎬 HomeYoutubeList 初始化完成', this.hyswiper);
            }

            disconnectedCallback() {
                if (this.hyswiper && this.hyswiper.destroy) {
                    this.hyswiper.destroy(true, true);
                    this.hyswiper = null;
                }
            }
        }
    );
}
